export default function Bento({
    blockOne,
    blockTwo,
    blockThree,
}: {
    blockOne: React.ReactNode;
    blockTwo: React.ReactNode;
    blockThree: React.ReactNode;
}) {
    return (
        <div className="py-2 sm:py-8">
            <div className="mx-auto max-w-2xl lg:max-w-7xl">
                <div className="mt-10 grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-5 lg:grid-rows-2">
                    <div className="relative lg:col-span-3 ">
                        <div className="absolute inset-px rounded-lg bg-[#FFFFFF] dark:bg-zinc-800  max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem] " />
                        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] text-black dark:text-white">
                            {blockOne}
                        </div>

                        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-md max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem] " />
                    </div>
                    <div className="relative lg:col-span-2">
                        <div className="absolute inset-px rounded-lg bg-[#FFFFFF] dark:bg-zinc-800  lg:rounded-tr-[2rem]" />
                        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] lg:rounded-tr-[calc(2rem+1px)] text-black dark:text-white">
                            {blockTwo}
                        </div>
                        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-md  lg:rounded-tr-[2rem]" />
                    </div>
                    <div className="relative lg:col-span-5 min-h-[200px] max-h-[300px]">
                        <div className="absolute inset-px rounded-lg bg-[#FFFFFF] dark:bg-zinc-800 lg:rounded-bl-[2rem]" />
                        <div className="relative flex h-full flex-col overflow-auto rounded-[calc(var(--radius-lg)+1px)] lg:rounded-bl-[calc(2rem+1px)] text-black dark:text-white">
                            {blockThree}
                        </div>
                        <div className="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-md  lg:rounded-bl-[2rem]" />
                    </div>
                </div>
            </div>
        </div>
    );
}
